import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { BackgroundImage } from "../../elements";
import gsap from 'gsap';
import { getOverallSettingsClasses, mobileIs, loadScrollMagic } from "../../utils/siteUtils";
import { motion } from "framer-motion";

import "./style.scss";
const HighlightDetails = ({ page, lang, rendering, fields }) => {
  const  { pc_image, m_image, m_video, pc_video, list } = fields
  const rootNode = useRef();
	const isMobile = mobileIs()
	const topImageEl = useRef()
	const listContentEl = useRef()
	const [currentIndex, setCurrentIndex] = useState(null)
	
	const mouseOver = (e, index) => {
		setCurrentIndex(index)
	}
	
	const mouseLeave = () => {
		setCurrentIndex(null)
	}
	
	const onScroll = () => {
		const winHeight = window.innerHeight || document.documentElement.clientHeight
		let titleDoms = document.querySelectorAll('.c-highlight-details .item-title')
		let descDoms = document.querySelectorAll('.c-highlight-details .item-desc')
		if(isMobile) {
			for(let i=0; i<titleDoms.length; i++) {
				if(titleDoms[i].getBoundingClientRect().top < winHeight + 50) {
					titleDoms[i].setAttribute('class', 'item-title active')
					if(descDoms[i]) {
						descDoms[i].setAttribute('class', 'item-desc active')
					}
					
				} else {
					titleDoms[i].setAttribute('class', 'item-title')
					if(descDoms[i]) {
						descDoms[i].setAttribute('class', 'item-desc')
					}
				}
			}
		}
	}
	
  useEffect(() => {
		let listHeight = document.querySelector('.highlight-list-content').clientHeight
		let ScrollMagic, controller, scene, scene2, tl, tl2
		ScrollMagic = loadScrollMagic()
		controller = new ScrollMagic.Controller()
		tl = gsap.timeline()
		tl2 = gsap.timeline()
		
		if(isMobile) {
			tl.add(gsap.to(topImageEl.current,{
			  scale: 1,
			}, 1))
			for (let i = 0; i < list.length; i++) {
				tl2.add(gsap.to(`#item__image${list[i].id}`, {
						transition: 1,
						scale: 1.1
				}),i)
			}
		} else {
			tl.add(gsap.to(topImageEl.current,{
			  scale: 1,
			}, 1))
			for (let i = 0; i < list.length; i++) {
				tl2.add(gsap.to(`#item__image${list[i].id}`, {
						transition: 1,
						scale: 1.1
				}),i)
			}
		}
		scene = new ScrollMagic.Scene({
		  triggerElement: rootNode.current,
		  triggerHook: 0,
		  offset: -window.innerHeight + (window.innerHeight/5)*2,
		  duration: window.innerHeight * 0.6
		})
		.setTween(tl)
		.addTo(controller)
		
		scene2 = new ScrollMagic.Scene({
			triggerElement: rootNode.current,
			triggerHook: 0,
			offset: window.innerHeight * 0.6,
			duration: listHeight - window.innerHeight * 0.6
		})
		.setTween(tl2)
		.addTo(controller)
		 
		window.addEventListener("scroll", onScroll)
		return () => {
			scene.destroy(true);
			scene = null;
			scene2.destroy(true);
			scene2 = null;
			controller.destroy(true);
			controller = null;
			window.removeEventListener("scroll", onScroll)
		};
  }, []);
  
  const rootClasses = classNames("c-highlight-details", getOverallSettingsClasses(fields));
	const image = isMobile ? m_image : pc_image
	const video = isMobile ? m_video : pc_video
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={rootNode}>
			{(image?.value?.src || video?.value?.src) && <div className="top-image-content">
				<div className="top-image-innercontent" ref={topImageEl}>
					{!video?.value?.src && <BackgroundImage {...image} className="top-image" />}
					{video?.value?.src && <video className="top-video" autoPlay={true} muted={true} loop={true}>
						<source type={video?.value?.mimeType} src={video?.value?.src} />
					</video>}
				</div>
			</div>}
			<div className="highlight-list-content" ref={listContentEl}>
				{list && list.map((item, index) => (
				  <div 
						className={["item", index%2 === 1 ? 'active' : '', (index%2 === 0 && index > 0) ? 'active1' : '', (index%2 === 1 && index > 1) ? 'active2' : '' ,currentIndex === index ? 'hide': ''].join(' ')}
						key={index}
						onMouseLeave={mouseLeave}
						onMouseOver={e => mouseOver(e, index)}
						>
						<div className="background-image-content">
							<motion.div
								className="background-image-innercontent"
								id={`item__image${item.id}`}
								>
								<BackgroundImage {...item.fields.image} className="item-image" />
							</motion.div >
						</div>
						<RichText tag="div" className="item-title" field={item.fields.title} />
						<RichText tag="div" className="item-desc" field={item.fields.desc} />
				  </div>
				))}
			</div>
    </div>
  )
};
export default HighlightDetails;
